<div class="message-popup-content">
  @for (page of previewPages; let pageIndex = $index; let isLast = $last; track pageIndex) {
    <div class="message-popup-header">
      <div class="air-waybill-gen-header">
        <span class="ibc-customer-heading-h5-light">Air Waybill</span>
        <mat-divider [vertical]="true"></mat-divider>
        <span class="ibc-customer-heading-h5-bold-primary-dark">
          {{ page.hawbExt }}
        </span>
      </div>
    </div>
    <div class="gen-air-waybill-container" [class.page-break]="!isLast">
      <div class="air-waybill-header">
        <img
          src="../../../../../../assets/images/ibc-customer-logo.svg"
          width="150"
          alt="ibc-logo" />
        <div class="ibc-address">
          <span class="ibc-customer-heading-h7-bold"
            >International Bonded Couriers Inc</span
          >
          <span class="ibc-customer-heading-regular">https://www.ibcinc.com</span>
          <span class="ibc-customer-heading-regular-light">888-SHIP-IBC</span>
        </div>
        <div class="barcode">
          <svg [id]="'barcode-' + pageIndex"></svg>
        </div>
      </div>
      <div class="shipper-consignee-piece-notes-details-container">
        @for (details of page.shipperConsigneeDetails; track details.name) {
          <div class="details-container">
            <div class="header">
              <span class="ibc-customer-heading-regular">{{
                details.type === 'S' ? 'Shipper' : 'Consignee'
              }}</span>
            </div>
            <div class="content">
              <div class="address-details">
                <span class="ibc-customer-heading-regular-semibold"
                  >{{ details.name }}</span
                >
                @if (details.companyName) {
                  <span class="ibc-customer-heading-regular"
                    >{{ details.companyName }}</span
                  >
                }
                <span class="ibc-customer-heading-regular"
                  >{{ details.address_1 }}</span
                >
                @if (details.address_2) {
                  <span class="ibc-customer-heading-regular"
                    >{{ details.address_2 }}</span
                  >
                }
                <span class="ibc-customer-heading-regular"
                  >{{ details.city }}@if (details.city && details.state) {&nbsp;}{{ details.state }}@if ((details.city || details.state) && details.zipCode) {&nbsp;}{{ details.zipCode }}
                </span>
                @if (details.country || details.countryCode) {
                  <span class="ibc-customer-heading-regular"
                    >{{ details.country || details.countryCode }}</span
                  >
                }
                @if (details.phone) {
                  <span class="ibc-customer-heading-regular">{{
                    details.phone
                  }}</span>
                }
              </div>
            </div>
          </div>
        }
        <div class="piece-level-details">
          <div class="header">
            <span class="ibc-customer-heading-regular">Piece Level Details</span>
          </div>
          <div class="content">
            <span class="ibc-customer-heading-regular"
              >Weight / Piece Detail Declaration</span
            >
            <app-summary-table
              [columnDefs]="page.tableColumnConfig"
              [tableData]="page.pieceTableData"
              [noDataMessage]="''"></app-summary-table>
          </div>
        </div>
        <div class="notes-container">
          <div class="header">
            <span class="ibc-customer-heading-regular">Notes</span>
          </div>
          <div class="content">
            <span class="ibc-customer-heading-regular">
              {{ page.notes }}
            </span>
          </div>
        </div>
      </div>
      <div class="shipment-details-container">
        <div class="header">
          <span class="ibc-customer-heading-regular">Shipment</span>
        </div>
        <div class="content">
          @for (
            shipment of page.shipmentDetails | keyvalue: shipmentDetailsOrderCompareFn;
            track shipment.key
          ) {
            <div class="key-value-container">
              <span class="ibc-customer-heading-regular-semibold"
                >{{ renderKey(shipment.key) }} :</span
              >
              <span class="ibc-customer-heading-regular">{{
                shipment.value
              }}</span>
            </div>
          }
        </div>
      </div>
      <div class="terms-and-condition-section">
        @for (info of page.termsAndCondition | keyvalue; track info.key) {
          <div>
            <span class="ibc-body-text-small-semi-bold">{{
              renderKey(info.key)
            }}</span>
            <span class="ibc-body-text-small">{{ info.value }}</span>
          </div>
        }
      </div>
    </div>
  }
</div>
